export default __webpack_public_path__ + "static/media/risk-accepted.867207c6.svg";